import {RealtimeInterface} from '../services/realtime/realtime-interface';
import {Role} from './auth/role.class';

export class User implements RealtimeInterface {
    id?: number;
    name: string;
    email: string;
    password: string;

    hourly_rate?: number;
    part_time_rate?: number;
    employment_start?: Date;
    employment_end?: Date;
    period_costs?: number;
    cur_month: number;
    prev_month: number;

    calendarUrl?: string;

    roles?: Role[];

    updated_at?: Date;
    deleted_at?: Date;
}
